// [NOTE_BREADCRUMBS]
const BREADCRUMBS = {
    "manager-meeting": "breadcrumbs.managerMeeting",
    "details": "breadcrumbs.details",
    "detail": "breadcrumbs.detail",
    "statistics": "breadcrumbs.statistics",
    "manager-whiteboard": "breadcrumbs.managerWhiteboard",
    "share-management": "breadcrumbs.shareWhiteboard",
    "manager-users": "breadcrumbs.userManagement",
    "manager-users/create": "breadcrumbs.create-user",
    "manager-users/update": "breadcrumbs.update-user",
    "manager-users/settings": "common:breadcrumbs.setting-user",
    "create-user": "breadcrumbs.create-user",
    "update-user": "breadcrumbs.update-user",
    "manager-recordings": "breadcrumbs.managerRecording",
    "detail-record": "breadcrumbs.detailRecord",
    "sharing-record": "breadcrumbs.sharingRecord",
    "access-log": "breadcrumbs.accessLog",
    "detail-mfa": "breadcrumbs.detail-mfa",
    "history-mfa": "breadcrumbs.history-mfa",
    "profile-user": "breadcrumbs.profile",
    "contacts": "breadcrumbs.phonebook",
    "organization": "breadcrumbs.organization",
    "manager-diary": "breadcrumbs.managerDiary",
    "manager-sip": "breadcrumbs.managerSip",
    "license": "breadcrumbs.license",
    "manager-user-sip": "breadcrumbs.manager-user-sip",
    "manager-user-sip/create": "breadcrumbs.create-user-sip",
    "manager-user-sip/edit": "breadcrumbs.edit-user-sip",
    "manager-roles": "breadcrumbs.manager-roles",
    "split-role": "breadcrumbs.split-role",
    "manager-function": "breadcrumbs.manager-function",
    "manager-systems": "breadcrumbs.manager-systems",
    "manager-historys": "breadcrumbs.manager-historys",
    "manager-backup": "breadcrumbs.manager-backup",
    "meeting-monitor": "breadcrumbs.meeting-monitor",
    "detail-monitor": "breadcrumbs.detail-monitor",
    "create-user-sip": "breadcrumbs.create-user-sip",
    "edit-user-sip": "breadcrumbs.edit-user-sip",
    "live-captions": "breadcrumbs.live-captions",
    "live-captions-detail": "breadcrumbs.live-captions-detail",
    "schedule-meeting/create": "breadcrumbs.createScheduleMeeting",
    "schedule-meeting/update": "breadcrumbs.updateScheduleMeeting",
    "schedule-meeting/copy": "breadcrumbs.copyScheduleMeeting",
    "history": "breadcrumbs.history",
    "service-package-management": "breadcrumbs.managerPackage",
    "member-management": "breadcrumbs.managerMember",
    "manager-function/create": "breadcrumbs.create-function",
    "manager-function/update": "breadcrumbs.update-function",
    "manager-role-function/update": "breadcrumbs.update-role",
    "content-landingpage": "breadcrumbs.contentLandingpage",
    "content-landingpage/create": "breadcrumbs.createContentLandingpage",
    "content-landingpage/update": "breadcrumbs.updateContentLandingpage",
    "manager-storage": "breadcrumbs.manager-storage",
    "manager-version": "breadcrumbs.manager-version",
    "manager-version/create": "breadcrumbs.manager-version-create",
    "manager-version/update": "breadcrumbs.manager-version-update",
    "manager-branding": "breadcrumbs.manager-branding",
    "mcu-control": "breadcrumbs.mcu-control",
    "mcu-status": "breadcrumbs.mcu-status",
    "mcu-settings": "breadcrumbs.mcu-settings",
    "control-room": "breadcrumbs.control-room",
    "groups": "breadcrumbs.phonebook-groups",
}

export { BREADCRUMBS }